export default () => {
    //script for scrollableX
    const scrollableDiv = document.querySelector(".js-scrollable");

    let isDown = false;
    let startX;
    let scrollLeft;

    if (scrollableDiv !== null) {

        scrollableDiv.addEventListener('mousedown', (e) => {
            if (e.button !== 0) return; // left mouse button
            isDown = true; // is down
            scrollableDiv.classList.add('active');
            startX = e.pageX - scrollableDiv.offsetLeft;
            scrollLeft = scrollableDiv.scrollLeft;
        });
        scrollableDiv.addEventListener('mouseleave', () => {
            isDown = false;
            scrollableDiv.classList.remove('active');
        });
        scrollableDiv.addEventListener('mouseup', () => {
            isDown = false;
            scrollableDiv.classList.remove('active');
        });
        scrollableDiv.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollableDiv.offsetLeft;
            const walk = (x - startX) * 1.25; // scroll-fast
            scrollableDiv.scrollLeft = scrollLeft - walk;
        });
    }

}
